import React from 'react';

export const Title = ({ animation, animationDesign }) => {
  // style={{ animation: animation }}

  return (
    <div className="page-header-title">
      <p style={{ animation: animation }}>ПРОФЕСІЙНА ЮРИДИЧНА ДОПОМОГА</p>
      <div className="design-title-block hd">
        {/* hd - header disgn */}
        <div
          className="design3 hd"
          style={{ animation: animationDesign }}
        ></div>
        <div
          className="design2 hd"
          style={{ animation: animationDesign }}
        ></div>
        <div
          className="design1 hd"
          style={{ animation: animationDesign }}
        ></div>
      </div>
    </div>
  );
};
